<template>
  <stat :title="title" :loading="loading">
    <purchases-chart
      :dataKey="dataKey"
      :height="200"
      :params="params"
      style="width: 100%"></purchases-chart>
  </stat>
</template>

<script>
  import { PurchasesChart } from '@/components/charts'
  import stats from '@/mixins/stats'
  export default {
    components: {
      PurchasesChart
    },
    mixins: [stats],
    props: {
      dataKey: {
        type: String,
        default: 'purchases'
      }
    },
    computed: {
      title () {
        if (!this.params.from || !this.params.to) {
          return this.$t('dashboard.purchases.title')
        }
        return [
          this.$d(new Date(this.params.from), 'short'),
          this.$d(new Date(this.params.to), 'short')
        ].join(' - ')
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/dashboard/Purchases.vue